import { render, staticRenderFns } from "./SetSchedule.vue?vue&type=template&id=baff2858&scoped=true&"
import script from "./SetSchedule.vue?vue&type=script&lang=js&"
export * from "./SetSchedule.vue?vue&type=script&lang=js&"
import style0 from "./SetSchedule.vue?vue&type=style&index=0&id=baff2858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff2858",
  null
  
)

export default component.exports